import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/sections/Hero";
import Services from "../components/sections/Services";
import Gallery from "../components/sections/Gallery";
import About from "../components/sections/About";
import Contact from "../components/sections/Contact";

const Home = () => {
  const [services, setServices] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    Promise.all([api.get("/services"), api.get("/gallery"), api.get("/site-info")])
      .then(([s, g, i]) => {
        setServices(s.data);
        setGallery(g.data);
        setInfo(i.data);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="bg-[#0A0A0C] min-h-screen" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Services services={services} />
        <Gallery items={gallery} />
        <About />
        <Contact info={info} />
      </main>
      <Footer info={info} />
    </div>
  );
};

export default Home;
